<template>
	<div class="incomeAll">
		<h6>使用介绍</h6>
		<div class="shiYong fwbhtml" v-html="introduce">
			<!-- <p>介绍介绍介绍介绍介绍介绍介绍</p>
               <img src="../../image/banner.png" /> -->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				introduce: '使用介绍'
			};
		},
		mounted: function() {
			this.GetBase();
		},
		methods: {
			// 获取使用介绍
			GetBase: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetWebSet',
					'GET', {},
					function(res) {
						console.log('获取使用介绍', res);
						if (res.code === 0) {
							that.introduce = res.data.WebInfo;
						}
					},
					function(res) {}
				);
			}
		}
	};
</script>

<style scoped>
	/deep/img {
		display: block;
		max-width: 100%;
	}

	.shiYong p {
		font-size: 14px;
		color: #000;
	}

	.shiYong {
		padding: 30px 20px;
	}

	/* safety */

	.incomeAll>h6 {
		border-bottom: solid 1px #e6e6e6;
		font-size: 16px;
		color: #333;
		height: 62px;
		line-height: 62px;
		text-indent: 20px;
		position: relative;
	}

	.incomeAll>h6::after {
		content: '';
		width: 68px;
		height: 2px;
		background-color: #333;
		position: absolute;
		left: 20px;
		bottom: 0;
		z-index: 0;
	}

	.no-pdf {
		display: flex;
		justify-content: space-around;
		padding: 0 40px;
	}
</style>
